import { SealingServiceComponentDesign } from '@paragon/contract-library';

import { SealingService } from '../connections';

export async function download(id: number) {
  const result = await SealingService.fetchFile(`componentDesigns/download?id=${id}`);

  result.download();
}

export function get(id: number): Promise<SealingServiceComponentDesign> {
  return SealingService.get(`componentDesigns/${id}`);
}

export function getByAnalysisRemoteKey(analysisRemoteKey: string, jobId: number) {
  return SealingService.get<SealingServiceComponentDesign | null>(
    `componentDesigns/byAnalysisRemoteKey/${analysisRemoteKey}?jobId=${jobId}`,
  );
}

export function createMultiple(
  data: readonly SealingServiceComponentDesign[],
): Promise<{ addedComponents: SealingServiceComponentDesign[]; corruptComponents: string[] }> {
  return SealingService.post('componentDesigns/batch', { data });
}

export function replace(data: SealingServiceComponentDesign): Promise<SealingServiceComponentDesign> {
  return SealingService.put(`componentDesigns/${data.id}`, { data });
}

export function remove(id: number) {
  return SealingService.delete(`componentDesigns/${id}`);
}
